import { css } from '@emotion/react';
import { Fragment } from 'react';
import Title from 'components/Title/Title';
import Page from 'components/Page/Page';
import Dashboard from './Dashboard';

export default function DashboardPage() {
  return (
    <Fragment>
      <Title>Dashboard | Tailor</Title>
      <Page>
        <div
          css={css`
            margin: 48px;

            @media (max-width: 767px) {
              margin: 12px;
            }
          `}
        >
          <Dashboard />
        </div>
      </Page>
    </Fragment>
  );
}
